export default __webpack_public_path__ + "f839a5806cd9b758435ea1c3cba88b3a.svg";